import FullScreenIcon from "@/common/images/icons/fullScreenIcon.svg?react";
import ExitFullScreenIcon from "@/common/images/icons/exitFullScreen.svg?react";
import { useAppStore } from "@/common/store/appStore";
import { mainBus } from "@/common/buses";
import { useCallback } from "react";
import "./FSButton.scss";

interface IFSButtonProps {
  feedItemId: string;
  mobile?: boolean;
  describedBy?: string;
}

export const FSButton: React.FC<IFSButtonProps> = ({
  feedItemId,
  mobile = false,
  describedBy
}) => {
  const isFullScreen = useAppStore((state) => mobile ? state.isMobileFullscreen : state.isFullScreen);

  const handleToggleFullScreen = useCallback(() => {
    mainBus.emit(mobile ? "toggle_mobile_fullscreen" : "toggle_fullscreen", { id: feedItemId });
  }, [feedItemId, mobile]);

  return (
    <button
      onClick={handleToggleFullScreen}
      className="FSButton"
      aria-label={`${isFullScreen ? "close" : "open"} fullscreen`}
      aria-describedby={describedBy}
    >
      {isFullScreen ? <ExitFullScreenIcon /> : <FullScreenIcon />}
    </button>
  );
};
